function getUrl(url, fullyQualified) {
  if (fullyQualified) {
    return process.env.NEXT_PUBLIC_APP_URL + url
  }
  return url
}

const paths = {
  serviceLab: ({ serviceLabId } = {}, fullyQualified = false) =>
    getUrl(`/service-lab/${serviceLabId}`, fullyQualified),

  serviceLabDevices: ({ serviceLabId } = {}, fullyQualified = false) =>
    getUrl(`/service-lab/${serviceLabId}/devices`, fullyQualified),

  serviceLabDevicesArchived: ({ serviceLabId } = {}, fullyQualified = false) =>
    getUrl(`/service-lab/${serviceLabId}/devices/archived`, fullyQualified),

  serviceLabDevice: ({ serviceLabId, deviceId } = {}, fullyQualified = false) =>
    getUrl(
      `/service-lab/${serviceLabId}/devices/view/${deviceId}`,
      fullyQualified
    ),

  serviceLabDeviceTestReports: (
    { serviceLabId, deviceId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/devices/view/${deviceId}/test-reports`,
      fullyQualified
    ),

  serviceLabDeviceCertificates: (
    { serviceLabId, deviceId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/devices/view/${deviceId}/certs`,
      fullyQualified
    ),

  serviceLabDeviceCertificatesArchived: (
    { serviceLabId, deviceId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/devices/view/${deviceId}/certs/archived`,
      fullyQualified
    ),

  serviceLabDeviceCertificate: (
    { serviceLabId, deviceId, certId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/devices/view/${deviceId}/certs/${certId}`,
      fullyQualified
    ),

  serviceLabDeviceHistory: (
    { serviceLabId, deviceId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/devices/view/${deviceId}/history`,
      fullyQualified
    ),

  serviceLabDeviceHistoryItem: (
    { serviceLabId, deviceId, historyItemId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/devices/view/${deviceId}/history/${historyItemId}`,
      fullyQualified
    ),

  serviceLabCustomers: ({ serviceLabId } = {}, fullyQualified = false) =>
    getUrl(`/service-lab/${serviceLabId}/customers`, fullyQualified),

  serviceLabCustomersArchived: (
    { serviceLabId } = {},
    fullyQualified = false
  ) =>
    getUrl(`/service-lab/${serviceLabId}/customers/archived`, fullyQualified),

  serviceLabCustomer: (
    { serviceLabId, customerId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/customers/view/${customerId}`,
      fullyQualified
    ),

  serviceLabUsers: ({ serviceLabId } = {}, fullyQualified = false) =>
    getUrl(`/service-lab/${serviceLabId}/account/users`, fullyQualified),

  serviceLabUser: ({ serviceLabId, userId } = {}, fullyQualified = false) =>
    getUrl(
      `/service-lab/${serviceLabId}/account/users/view/${userId}`,
      fullyQualified
    ),

  serviceLabUsersArchived: ({ serviceLabId } = {}, fullyQualified = false) =>
    getUrl(
      `/service-lab/${serviceLabId}/account/users/archived`,
      fullyQualified
    ),

  serviceLabRsvp: (
    { serviceLabId, invitationCode } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/rsvp/${invitationCode}`,
      fullyQualified
    ),

  serviceLabTestReports: ({ serviceLabId } = {}, fullyQualified = false) =>
    getUrl(`/service-lab/${serviceLabId}/test-reports`, fullyQualified),

  serviceLabTestReportsArchived: (
    { serviceLabId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/test-reports/archived`,
      fullyQualified
    ),

  serviceLabTestReport: (
    { serviceLabId, testReportId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/test-reports/view/${testReportId}`,
      fullyQualified
    ),

  serviceLabCalibrationReports: (
    { serviceLabId } = {},
    fullyQualified = false
  ) => getUrl(`/service-lab/${serviceLabId}/certification`, fullyQualified),

  serviceLabCalibrationReportsApproved: (
    { serviceLabId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/certification/approved`,
      fullyQualified
    ),
  serviceLabCalibrationReportsPending: (
    { serviceLabId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/certification/pending`,
      fullyQualified
    ),
  serviceLabCalibrationReportsArchived: (
    { serviceLabId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/certification/archived`,
      fullyQualified
    ),

  serviceLabCalibrationReport: (
    { serviceLabId, calibrationReportId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/certification/view/${calibrationReportId}`,
      fullyQualified
    ),

  serviceLabReferenceDevices: ({ serviceLabId } = {}, fullyQualified = false) =>
    getUrl(`/service-lab/${serviceLabId}/references`, fullyQualified),

  serviceLabReferenceDevicesArchived: (
    { serviceLabId } = {},
    fullyQualified = false
  ) =>
    getUrl(`/service-lab/${serviceLabId}/references/archived`, fullyQualified),

  serviceLabReferenceDevice: (
    { serviceLabId, referenceId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/references/view/${referenceId}`,
      fullyQualified
    ),

  serviceLabProductData: ({ serviceLabId } = {}, fullyQualified = false) =>
    getUrl(`/service-lab/${serviceLabId}/product-data`, fullyQualified),

  serviceLabProductDataManufacturers: (
    { serviceLabId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/product-data/manufacturers`,
      fullyQualified
    ),

  serviceLabProductDataProductTypes: (
    { serviceLabId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/product-data/product-types`,
      fullyQualified
    ),

  serviceLabProductDataProducts: (
    { serviceLabId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/product-data/products`,
      fullyQualified
    ),

  // Product data detail and archived pages
  serviceLabProductDataManufacturer: (
    { serviceLabId, manufacturerId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/product-data/manufacturers/view/${manufacturerId}`,
      fullyQualified
    ),

  serviceLabProductDataProduct: (
    { serviceLabId, productId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/product-data/products/view/${productId}`,
      fullyQualified
    ),

  serviceLabProductDataProductType: (
    { serviceLabId, productTypeId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/product-data/product-types/view/${productTypeId}`,
      fullyQualified
    ),

  serviceLabProductDataManufacturersArchived: (
    { serviceLabId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/product-data/manufacturers/archived`,
      fullyQualified
    ),

  serviceLabProductDataProductsArchived: (
    { serviceLabId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/product-data/products/archived`,
      fullyQualified
    ),

  serviceLabProductDataProductTypesArchived: (
    { serviceLabId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/product-data/product-types/archived`,
      fullyQualified
    ),

  serviceLabProductDataModelsArchived: (
    { serviceLabId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/product-data/models/archived`,
      fullyQualified
    ),

  serviceLabProductDataModel: (
    { serviceLabId, modelId } = {},
    fullyQualified = false
  ) =>
    getUrl(
      `/service-lab/${serviceLabId}/product-data/models/view/${modelId}`,
      fullyQualified
    ),

  serviceLabProductDataModels: (
    { serviceLabId } = {},
    fullyQualified = false
  ) =>
    getUrl(`/service-lab/${serviceLabId}/product-data/models`, fullyQualified),

  adminProduct: ({ productId } = {}, fullyQualified = false) =>
    getUrl(
      `/admin/master-product-admin/products/view/${productId}`,
      fullyQualified
    ),
  adminProducts: (_, fullyQualified = false) =>
    getUrl(`/admin/master-product-admin/products`, fullyQualified),

  adminProductsArchived: (_, fullyQualified = false) =>
    getUrl(`/admin/master-product-admin/products/archived`, fullyQualified),
  adminManufacturer: ({ manufacturerId } = {}, fullyQualified = false) =>
    getUrl(
      `/admin/master-product-admin/manufacturers/view/${manufacturerId}`,
      fullyQualified
    ),
  adminManufacturers: (_, fullyQualified = false) =>
    getUrl(`/admin/master-product-admin/manufacturers`, fullyQualified),

  adminManufacturersArchived: (_, fullyQualified = false) =>
    getUrl(
      `/admin/master-product-admin/manufacturers/archived`,
      fullyQualified
    ),
  adminModel: ({ modelId } = {}, fullyQualified = false) =>
    getUrl(
      `/admin/master-product-admin/models/view/${modelId}`,
      fullyQualified
    ),
  adminModels: (_, fullyQualified = false) =>
    getUrl(`/admin/master-product-admin/models`, fullyQualified),

  adminModelsArchived: (_, fullyQualified = false) =>
    getUrl(`/admin/master-product-admin/models/archived`, fullyQualified),
  adminProductType: ({ productTypeId } = {}, fullyQualified = false) =>
    getUrl(
      `/admin/master-product-admin/product-types/view/${productTypeId}`,
      fullyQualified
    ),
  adminProductTypes: (_, fullyQualified = false) =>
    getUrl(`/admin/master-product-admin/product-types`, fullyQualified),

  adminProductTypesArchived: (_, fullyQualified = false) =>
    getUrl(
      `/admin/master-product-admin/product-types/archived`,
      fullyQualified
    ),

  adminServiceLabs: (_, fullyQualified = false) =>
    getUrl(`/admin/customer-admin/service-labs`, fullyQualified),

  adminServiceLab: ({ serviceLabId } = {}, fullyQualified = false) =>
    getUrl(
      `/admin/customer-admin/service-labs/view/${serviceLabId}`,
      fullyQualified
    ),

  adminServiceLabsArchived: (_, fullyQualified = false) =>
    getUrl(`/admin/customer-admin/service-labs/archived`, fullyQualified),

  adminUsers: (_, fullyQualified = false) =>
    getUrl(`/admin/customer-admin/users`, fullyQualified),

  adminUser: ({ userId } = {}, fullyQualified = false) =>
    getUrl(`/admin/customer-admin/users/view/${userId}`, fullyQualified),
}

export default paths
